export function rowsCount(heightRow: number, diff = 0) {
    const container = document.getElementById("table-container");
    if (container) {
        const height = container.getBoundingClientRect().height;
        return Math.floor((height - heightRow - 40 - diff) / heightRow);
    }
    return 1;
}